export enum UserDocumentCategory {
  uncategorized = 'uncategorized',
  KycDocument = 'kyc-document',
  other = 'other',

  /* Tenants */
  identification = 'identification',
  proofOfIncome = 'proof-of-income',
  proofOfOccupation = 'proof-of-occupation',
  bookingCancellations = 'booking-cancellations',
  /* Advertisers */
  rentalAgreements = 'rental-agreements',
  rulesAndRequirements = 'rules-and-requirements',
}

export enum UserDocumentMimeType {
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  PPT = 'application/vnd.ms-powerpoint',
  PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  PDF = 'application/pdf',
  JPG = 'image/jpeg',
  PNG = 'image/png',
  WEBP = 'image/webp',
}

export interface UserDocument {
  category: UserDocumentCategory;
  createdAt: string;
  filename: string;
  id: number;
  mimeType: UserDocumentMimeType | string;
  planedDeletionDate: string;
  size: number;
  title: string;
  updatedAt: string;
  uuid: string;
}

export interface SharedDocument {
  category: UserDocumentCategory;
  filename: string;
  title: string;
  redirectUrl: string;
  mimeType: UserDocumentMimeType | string;
}

export type SharedDocumentsResponse = {
  documents: Array<SharedDocument>;
};

export type RequestUserDocumentResponse = {
  contentType: string;
  documentId: number;
  documentUuid: string;
  expires: string;
  url: string;
};

export interface RequestUserDocumentViewUrl {
  url: string;
  expires: string;
}
